import classnames from "classnames";

export const combineStyles = <T extends object>(orig: T, merge): T => {
    if (!merge) return orig;

    const result = {};
    Object.keys(orig).forEach(k => {
        const newStyle = classnames(orig[k], {
            [merge[k]]: !!merge[k],
        });
        result[k] = newStyle;
    });
    return result as T;
};
